import React from 'react';
import Page from './page';

export const Novedad = ({icono, titulo, contenido}) => {
  return (
      <Page {...{icono, titulo, contenido}}/>
  );
}

export default Novedad;